<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
           :key="isSmallerScreen" :value="active_step">

    <!-- GENERAL -->
    <vs-tab @click="onClickTabs(0)" v-if="$canAny(['view-staff','create-edit-staff'])"  icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? ' Staff' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <staff-users/>
      </div>
    </vs-tab>
    <vs-tab @click="onClickTabs(1)" v-if="$canAny(['view-staff-role','create-edit-staff-role'])" icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Staff Group Profiles' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <staff-group-profile/>
      </div>
    </vs-tab>
    <vs-tab @click="onClickTabs(2)" v-if="$canAny(['view-staff-departments','create-edit-staff-departments'])" icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? ' Departments & Teams' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <staff-departments/>
      </div>
    </vs-tab>
    <vs-tab @click="onClickTabs(3)" v-if="$canAny(['view-staff-leaves', 'create-staff-leaves', 'edit-staff-leaves'])" icon-pack="feather" icon="icon-moon" :label="!isSmallerScreen ? ' Manage Leave' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <ManageStaffLeaves/>
      </div>
    </vs-tab>
    <vs-tab @click="onClickTabs(4)" v-if="$can('create-edit-staff-skills-qualifications')" icon-pack="feather" icon="icon-database" :label="!isSmallerScreen ? ' Skills & Qualifications' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <ManageStaffSkillsQualificationHome/>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import StaffUsers from './tabs/StaffUsers.vue'
import StaffGroupProfile from './tabs/StaffGroupProfile.vue'
import StaffDepartments from './tabs/StaffDepartments.vue'
import TreeTest from './tabs/TreeTest.vue'
import ManageStaffLeaves from './tabs/manage-leaves/ManageStaffLeaves.vue'
import ManageStaffSkillsQualificationHome from './tabs/manage-skills-qualifications/ManageStaffSkillsQualificationHome.vue'
// import PendingUsersList from './PendingUsersList.vue'
import Vue from 'vue';


export default {
  components: {
    StaffUsers,
    StaffGroupProfile,
    StaffDepartments,
    TreeTest,
    ManageStaffLeaves,
    // PendingUsersList,
    ManageStaffSkillsQualificationHome,
  },
  data () {
    return {
      isActiveManageStaff: this.$can('view-staff'),
      active_step: this.$route.query.step ? this.$route.query.step : '0'
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  mounted() {
  },
  methods: {
    onClickTabs(step) {
      this.$router.push({query: {step: step} });
    }
  }
}
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
